export var clientMultipleContactsMapper = function (data) {
    var result = [];
    if (data && data.length > 0) {
        result = data.map(function (item, index) {
            return (index < 5) ? {
                acCode: item.acCode,
                contactType: item.contactType,
                contactNo: item.contactNo,
                retypeContactNo: item.retypeContactNo,
                createdBy: item.createdBy,
                mode: item.mode,
                contactID: item.contactID,
                createdDate: item.createdDate,
                iSSHOW: item.isshow,
                isdIsPlay: item.isdisplay,
            } : null;
        }).filter(function (x) { return x; });
    }
    return result;
};
